import Loadable from './Loadable';
import reducer from './modules/alarms.slice';
import saga from 'containers/App/modules/entities/alarms/alarmsEntity.saga';

export default {
	component: Loadable,
	saga,
	reducer
};